<template>
  <div>
    <h1 class="title">Search All POs</h1>
    <form @submit.prevent="loadData">
      <b-field>
        <b-input expanded placeholder="Search All POs..." v-model="search" rounded icon="search"></b-input>
        <span v-if="search" class='control'>
            <button class="button is-rounded" type="button" @click='clear'>Clear</button>
        </span>
      </b-field>
      <!--<b-input placeholder="Search All POs..." v-model="search" rounded type="search" icon="search"></b-input>-->
    </form>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <b-table :data="orderData" narrowed>
      <template slot-scope="props">
        <b-table-column label="PO #">
          {{props.row.poNumber}}
        </b-table-column>
        <b-table-column label="Vendor Name">
          {{props.row.vendorName}}
        </b-table-column>
        <b-table-column label="Purchasing Agent">
          {{props.row.purchasingAgent}}
        </b-table-column>
        <b-table-column label="Date Ordered">
          {{props.row.orderDate}}
        </b-table-column>
        <b-table-column label="Invoice Total">
          $ {{props.row.zcnTotalAmountDue.toLocaleString()}}
        </b-table-column>
        <!--<b-table-column label="">-->
        <!--  <b-field style="color: #d00a0a" >-->
        <!--    {{props.row.zctStatus}}-->
        <!--  </b-field>-->
        <!--</b-table-column>-->
        <b-table-column label="">
            <!--<button class="button" @click="edit(props.row.__kptID)">Edit</button>-->
            <button class="button" @click="edit(props.row.__kptID)">{{viewEdit(props.row.purchasingAgent)}}</button>

        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapMutations } from 'vuex';
import store from '../../store/store.js';
const PORTAL = 'purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID'

  export default {
  name: 'AllPOs',
  props: ['data'],
  data () {
    return {
      orderData: [],
      isLoading: false,
      isFullPage: false,
      search: ""
    };
  },
  computed:{
    ...mapState([
      'newPurchaseOrderNumber',
      'userInfo',
    ]),
    query: function(){
      // Matt West is manager and needs to be able to see his and Matt Parker's POs
      if( this.search == "" && this.userInfo.employeeID != '5C81371F-EEF5-483D-9713-DC9C441E9EF1'){
        return [{
          "poNumber" : "*",
          "purchasingAgent": this.userInfo.employeeName,
        }]
      }
      else if(this.search == ""){
        return [
          {
            "poNumber" : "*",
            "purchasingAgent": this.userInfo.employeeName,
          },
          {
            "poNumber" : "*",
            "purchasingAgent": "Matt Parker",
          }
        ]
      }
      
      // If Matt West is searching
      else if(this.userInfo.employeeID == '5C81371F-EEF5-483D-9713-DC9C441E9EF1'){
        return [
          {
            "poNumber": this.search,
            "purchasingAgent": this.userInfo.employeeName
          },
          {
            "vendorName": this.search,
            "purchasingAgent": this.userInfo.employeeName
          },
          // {
          //   "purchasingAgent": this.search,
          //   "purchasingAgent": this.userInfo.employeeName
          // },
          {
            "zcnTotalAmountDue": this.search,
            "purchasingAgent": this.userInfo.employeeName
          },
          {
            "orderDate": this.search,
            "purchasingAgent": this.userInfo.employeeName
          },
          {
            "purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::description": this.search,
            "purchasingAgent": this.userInfo.employeeName
          },
          {
            "poNumber": this.search,
            "purchasingAgent": "Matt Parker"
          },
          {
            "vendorName": this.search,
            "purchasingAgent": "Matt Parker"
          },
          // {
          //   "purchasingAgent": this.search,
          //   "purchasingAgent": "Matt Parker"
          // },
          {
            "zcnTotalAmountDue": this.search,
            "purchasingAgent": "Matt Parker"
          },
          {
            "orderDate": this.search,
            "purchasingAgent": "Matt Parker"
          },
          {
            "purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::description": this.search,
            "purchasingAgent": "Matt Parker"
          }
        ]
      }
      // Other users searching
      return [ 
        {
          "poNumber": this.search,
          "purchasingAgent": this.userInfo.employeeName
        },
        {
          "vendorName": this.search,
          "purchasingAgent": this.userInfo.employeeName
        },
        {
          "department": this.search,
          "purchasingAgent": this.userInfo.employeeName
        },
        {
          "orderDate": this.search,
          "purchasingAgent": this.userInfo.employeeName
        },
        {
          "purchasingAgent": this.search,
        },
        {
          "zcnTotalAmountDue": this.search,
          "purchasingAgent": this.userInfo.employeeName
        },
        {
          "purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::description": this.search,
          "purchasingAgent": this.userInfo.employeeName
        }
      ];
    },
    searchQuery: function(){
      var searchQuery = {
          "query": this.query,
          "sort":[{
              "fieldName": "zctSortPoNumber",
              "sortOrder": "ascend"
          }],
          "limit": "9999",
      };
      return searchQuery;
    }
  },
  created: function() {
    this.loadData();
  },
  methods: {
    ...mapMutations([
      'updateNewPoNumber'
    ]),
    viewEdit: function(purchasingAgent){
      if(purchasingAgent == this.userInfo.employeeName){
        return 'Edit';
      }
      else{
        return 'View';
      }
    },
    // Loads purchase orders based on search criteria
    loadData: function(){
      this.isLoading = true;
      var self = this;
      this.$http.post('api/v2/find.php?layout=purchaseOrder-dashboard-list', this.searchQuery)
      .then( response => {
          if(response.data.messages[0].code === "401"){
              this.$toast.open(response.data.messages[0].message);
              self.isLoading = false;
              return;
          }
          if(response.data.messages[0].code != 0){
              this.$toast.open(response.data.messages[0].message);
              self.isLoading = false;
              return;
          }
          self.orderData = [];
          response.data.response.data.forEach(function(record){
              self.orderData.push(record.fieldData);
          });

          self.isLoading = false;
      })
      .catch( error => {
          if (error.response) {
              this.$toast.open(error.response.status);
          } 
          else {
              this.$toast.open("Unknown Error");
          }
          self.isLoading = false;
      });
    },
    
    // Goes to the edit PO page for the selected PO
    edit: function(orderID){
      this.$router.push({name: 'PurchaseOrderReceivePage', params: { id: orderID }});
    },
    clear: function(){
      this.search = "";
      this.loadData();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .button {
    background-color: #d00a0b;
    color: white;
  }
</style>


// WEBPACK FOOTER //
// src/pages/Search/AllPOs.vue